import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { resetEnrichment } from '../../redux/actions/ioc';

export const BackButton = () => {
  const history = useHistory();

  function useQuery() {
    return new URLSearchParams(window.location.search);
  }

  const q = useQuery();

  function handleBackClick() {
    resetEnrichment();
    if (q?.get('backLink')) {
      if (q?.get('queryFormEncoded')) {
        history.push({
          pathname: `${q?.get('backLink')}`,
          state: atob(q?.get('queryFormEncoded')),
        });
      } else {
        history.push(`${q?.get('backLink')}`);
      }
    }
  }

  return (
    <div>
      {q?.get('backLink') ? (
        <div
          className="threatRankingBackButton"
          onClick={() => handleBackClick()}
        >
          <span
            style={{
              fontSize: '12px',
              color: 'white',
              opacity: '0.65',
              textAlign: 'left',
            }}
          >
            <>
              <ArrowLeftOutlined /> <span>Back</span>
            </>
          </span>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};
